import { useState } from "react";
import { Alert, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form } from "react-final-form";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { LabDocumentForm } from "./LabDocumentForm";
import { snakifyKeys } from "../../../util/helpers";

export const CreateLabDocumentModal = ({ labId, onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    setError(null);
    try {
      values.lab_id = labId;
      const res = await api.post("/admin/lab_documents", { lab_document: snakifyKeys(values) });

      if (onCreate) {
        onCreate(res.data);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Document...
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Create New Document</ModalHeader>

        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}

          <Form onSubmit={handleCreate}>{(props) => <LabDocumentForm {...props} />}</Form>
        </ModalBody>
      </Modal>
    </>
  );
};
